import React, { useEffect } from "react";
import { Button, Layout, Menu } from "antd";
import { useLocation, useNavigate } from "react-router-dom"; // Assuming you're using React Router
import Sider from "antd/es/layout/Sider";
import AuthenticatedMenuItems from "./AuthenticatedMenuItems";
import AssetPath from "../AssetPath/AssetPath";

const { Content } = Layout;

const AuthenticatedLayout = (props) => {
  const location = useLocation();
  const isHome = location.pathname === "/"; // Assuming the home page URL is "/"

  useEffect(() => {
    window.scrollTo(0, 0);

    // Add or remove "home" class from body element
    if (isHome) {
      document.body.classList.add("home");
    } else {
      document.body.classList.remove("home");
    }

    // Clean up the class on unmount
    return () => {
      document.body.classList.remove("home");
    };
  }, [location, isHome]);

  const navigate = useNavigate();

  const onLogout = () => {
    localStorage.removeItem("PHARMA_SOS_USER");
    navigate("/");
  };

  const items = AuthenticatedMenuItems.map((item, index) => ({
    key: index.toString(),
    label: item.title,
    onClick: () => navigate(item.link),
  }));

  return (
    <Layout style={{ minHeight: "100vh" }} className="site-layout" hasSider>
      <Sider className="bg-white border-end" width={240}>
        <div className="brand p-3 border-bottom">
          <img
            src={AssetPath.brand.pharmaSos}
            alt="Pharma-SOS"
            style={{ height: "35px" }}
          />
        </div>
        <Menu
          theme="light"
          mode="inline"
          defaultSelectedKeys={["1"]}
          items={items}
          className="bg-transparent p-2"
        />
        <div className="p-3">
          <Button
            type="primary"
            variant="solid"
            onClick={onLogout}
            className="w-100 mt-8"
          >
            Logout
          </Button>
        </div>
      </Sider>
      <Layout>
        <Content className="p-3">{props.children}</Content>
      </Layout>
    </Layout>
  );
};

export default AuthenticatedLayout;
